import React, { Children } from 'react';
import { Card } from './Card';
// import CardMedia from '@material-ui/core/CardMedia';

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  cardHeader: {
    textAlign: 'center',
    borderRadius: '2px',
    padding: '20px 30px',
    margin: '-80px 20px 0',
    backgroundColor: theme.palette.secondary.main,
  },
}));

export function CardHeader(props) {
  const classes = useStyles();
  const { children, ...rest } = props;
  return (
    <Card raised {...rest} className={classes.cardHeader}>
      {props.children}
    </Card>
  );
}
